// imported first by main.js: some toxilibs modules fetch their files (prism themes) while being evaluated.
// Relative to the page base, so it lands in the build folder in prod (see esbuild_config.js `copy`).
window.toxilibsBaseUrl = 'toxilibs/'
